var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 76.99 77.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffe234;}.cls-2{fill:#ff5a72;}.cls-3{fill:#6031e6;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.62,22.68a4.08,4.08,0,0,1,4.06-4.06H55L66.38,7.26A4.24,4.24,0,0,0,64,0a4.58,4.58,0,0,0-.53,0H5.4A5.42,5.42,0,0,0,0,5.4V63.48A4.58,4.58,0,0,0,0,64a4.24,4.24,0,0,0,7.23,2.37L18.62,55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.31,14.57H19.57a5,5,0,0,0-5,5V59.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M73.72,14.6a5.25,5.25,0,0,0-.56,0H59.31L14.57,59.31V73.24a3.86,3.86,0,0,0,6.59,2.7L75.82,21.28C78.08,19,76.89,15,73.72,14.6Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.111986893be0615d78cd86014d028a93.svg";
export { ForwardRef as ReactComponent };